import React, { useState } from "react";
import { Colors } from "../utils/style";
import {
  Alert,
  Button,
  Col,
  Container,
  Placeholder,
  Row,
  Spinner,
} from "react-bootstrap";
import CardComponent from "./CardComponent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCommentDots } from "@fortawesome/free-solid-svg-icons";
import { useStore } from "../store";
import axios from "axios";
import CodeCardComponent from "./CodeCardComponent";
import { useTranslation } from 'react-i18next';
import i18n from "../i18n";
import CreditModal from "./CreditModal";
import { axiosInstance } from "../App";

function ExplainContainer(props: PropTypes) {
  const { code, setCode } = useStore();
  const {selectedGoal, setSelectedGoal} = useStore();
  const { explanations, setExplanations } = useStore();
  const { selectedFileName, setSelectedFileName } = useStore();
  const [uploadError, setUploadError] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { t } = useTranslation("ExplainContainer");

  const [loading, setLoading] = useState(false);
  function onClickHandle() {
    setExplanations(null);
    setLoading(true);
    setUploadError(false);
    const requestBody = {
        filename: selectedFileName,
      goal: selectedGoal,
      code: code,

    };
    axiosInstance
      .post(process.env.REACT_APP_API_HOST + "visualize_user_data/explain", requestBody, {
        headers: {
          "Content-Type": "application/json",
          "Referrer-Policy": "no-referrer",
          Authorization: "Bearer " + localStorage.getItem("tokenLida"),
          "Accept-Language": i18n.language, // Add current language
        },
      })
      .then((response) => {
        setExplanations(response.data.explanations);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        setUploadError(true);
        console.error("Error uploading file:", error);

        if (error.response && error.response.status === 402) {
          // Show payment modal
          setIsModalOpen(true);
        }
      });
  }

  return (
  <>
    <div
      style={{
        backgroundColor: Colors.DARK_GRAY,
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
      }}
    >
      <div>
        {t("ExplanationPrompt")}
      </div>
      <Button
        style={{
          width: "7rem",
        }}
        variant="success"
        onClick={onClickHandle}
      >
        <FontAwesomeIcon icon={faCommentDots} /> {t("ExplainButton")}
      </Button>
      {loading && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "1rem",
          }}
        >
          <Spinner animation="grow" variant="success" />
          <Placeholder xs={12} size="lg" bg="light" />
          <Placeholder xs={12} size="lg" bg="light" />
          <Placeholder xs={12} size="lg" bg="light" />
          <Placeholder xs={12} size="lg" bg="light" />
          <Placeholder xs={12} size="lg" bg="light" />
          <Placeholder xs={12} size="lg" bg="light" />
        </div>
      )}
      {uploadError && (
                  <></>

      )}

      <Container className="mt-3">
        <Row md={2} xs={2} lg={2} sm={2}>
          {explanations?.map((item) => (
            <>
              <Col style={{ padding: "0.5rem" }}>
                <CardComponent
                  title={item.section || undefined}
                  description={item.explanation}
                ></CardComponent>
              </Col>
              <Col style={{ padding: "0.5rem" }}>
                <CodeCardComponent
                  title="code"
                  code={item.code}
                ></CodeCardComponent>
              </Col>
            </>
          ))}
        </Row>
      </Container>
    </div>
  
  
  </>
  );
}

type PropTypes = {};

export default ExplainContainer;
